export const toCurrency = (number = 0) => {
  if (!number) return '-';
  return new Intl.NumberFormat(localStorage.getItem('lang') || 'de', {
    style: 'currency',
    currency: 'EUR',
  }).format(number);
};
